
import vueTelegramLogin from '@/components/login/vue-telegram-login.vue'

export default {
  components: {
    'vue-telegram-login': vueTelegramLogin
  },
  props: {
    loginRegiswitch: {
      // 登录注册切换状态
      type: String,
      default: ''
    },
    switchState: {
      // 显示状态
      type: String,
      default: ''
    }
  },
  data() {
    return {
      clientId: '720725194691-5mlhk8dgsc12gg9409g8bthqhhras28p.apps.googleusercontent.com',
      googleBtnConfigs: {
        type: 'icon',
        shape: 'rectangular',
        theme: 'outline',
        text: 'continue_with',
        size: 'large',
        locale: 'es-419',
        logo_alignment: 'center',
        width: 400
        // locale: "zh_CN"
      },

      // icon: [
      //   { icon: 'https://resources1.interface003.com/web20/img/login/weixin.svg', type: 1, url: null },
      //   { icon: 'https://resources1.interface003.com/web20/img/login/facdbook.svg', type: 2, url: null },
      //   { icon: 'https://resources1.interface003.com/web20/img/login/Google.svg', type: 3 },
      //   { icon: 'https://resources1.interface003.com/web20/img/login/apple.svg', type: 4 }
      //   // { icon: 'https://resources1.interface003.com/web20/img/login/Tuite.svg', type: 5 },
      //   // { icon: 'https://resources1.interface003.com/web20/img/login/live.svg', type: 6 }
      // ],
      icon2: [
        {
          icon: 'https://resources1.interface003.com/web20/img/login/weixin.svg',
          type: 1,
          url: null,
          name: this.$v('微信')
        },
        {
          icon: 'https://resources1.interface003.com/web20/img/login/facdbook.svg',
          type: 2,
          url: null,
          name: 'Facebook'
        }
      ],
      Tripartite: [],
      languageCode: this.$store.state.LanguageCode, // 当前选择的语言
      isAdin: true,
      popupRef: null,
      popUpIntervalRef: null
    }
  },
  computed: {
    icon() {
      // tab栏
      const isCn = this.$store.state.myCountry == 'cn' //  this.$store.state.myCountry == 'cn'
      if (isCn) {
        // 是否为马甲号
        return [
          // cn只有微信 facdbook apple
          {
            icon: 'https://resources1.interface003.com/web20/img/login/weixin.svg',
            type: 1,
            url: null
          },
          {
            icon: 'https://resources1.interface003.com/web20/img/login/facdbook.svg',
            type: 2,
            url: null
          },
          {
            icon: 'https://resources1.interface003.com/web20/img/login/apple.svg',
            type: 4
          }
        ]
      } else if (this.$store.state.userlogin2) {
        return [
          {
            icon: 'https://resources1.interface003.com/web20/img/login/weixin.svg',
            type: 1,
            url: null
          },
          {
            icon: 'https://resources1.interface003.com/web20/img/login/facdbook.svg',
            type: 2,
            url: null
          },
          {
            icon: 'https://resources1.interface003.com/web20/img/login/Google.svg',
            type: 3
          },
          {
            icon: 'https://resources1.interface003.com/web20/img/login/apple.svg',
            type: 4
          },
          {
            icon: 'https://resources1.interface003.com/web20/img/class/icon_linkedin.svg',
            type: 8
          }
        ]
      } else if (this.$store.state.host.includes('wikifx.com')) {
        return [
          {
            icon: 'https://resources1.interface003.com/web20/img/login/weixin.svg',
            type: 1,
            url: null
          },
          {
            icon: 'https://resources1.interface003.com/web20/img/login/facdbook.svg',
            type: 2,
            url: null
          },
          {
            icon: 'https://resources1.interface003.com/web20/img/login/Google.svg',
            type: 3
          },
          {
            icon: 'https://resources1.interface003.com/web20/img/login/apple.svg',
            type: 4
          },
          {
            icon: 'https://resources1.interface003.com/web20/img/class/telegram.svg',
            type: 7
          },
          {
            icon: 'https://resources1.interface003.com/web20/img/class/icon_linkedin.svg',
            type: 8
          }
        ]
      } else {
        return [
          {
            icon: 'https://resources1.interface003.com/web20/img/login/weixin.svg',
            type: 1,
            url: null
          },
          {
            icon: 'https://resources1.interface003.com/web20/img/login/facdbook.svg',
            type: 2,
            url: null
          },
          {
            icon: 'https://resources1.interface003.com/web20/img/login/Google.svg',
            type: 3
          },
          {
            icon: 'https://resources1.interface003.com/web20/img/login/apple.svg',
            type: 4
          },
          {
            icon: 'https://resources1.interface003.com/web20/img/class/icon_linkedin.svg',
            type: 8
          }
        ]
      }
    }
  },
  mounted() {
    this.getTripartite() // 获取三方地址
    if (window.innerWidth <= 500) this.isAdin = false
  },
  methods: {
    popmessage(item) {
      console.log('item', item)
      if (item.url && this.$store.state.userlogin2) {
        const postdata = {
          op_type: 'opennew',
          url: `${item.url}&fromurl=##&middlepage=${`https://${this.$store.state.host}/${this.languageCode}/return.html`}`,
          parm: ''
        }
        window.parent.postMessage(postdata, '*')
      }
    },
    yourCallbackFunction(user) {
      const that = this
      that.$api.usercenter
        .getWaistcoat(
          {
            auth_date: user.auth_date,
            first_name: user.first_name,
            hash: user.hash,
            last_name: user.last_name,
            id: user.id,
            photo_url: user.photo_url ? user.photo_url : ''
          },
          {
            HttpMethod: 'post',
            Route: 'usercenter$telegramcallback'
          }
        )
        .then((res) => {
          that.googleLogin(res)
          console.log('telegram登录', res)
        })
        .catch((err) => {
          console.log(err)
        })
      console.log(user)
    },
    Register() {
      this.$emit('loginSwitch')
    },
    async getTripartite() {
      // 获取三方地址
      const { succeed = false, extra = '', result = {} } = await this.$api.login.userThird()
      if (!succeed) return console.log(extra) // 数据错误
      this.Tripartite = result
      if (this.switchState == 1 || this.switchState == 2) {
        this.icon.forEach((item) => {
          result.forEach((e) => {
            if (item.type == 1 && e.LoginType == 'Wechat') item.url = e.LoginUrl
            if (item.type == 2 && e.LoginType == 'FaceBook') item.url = e.LoginUrl
            if (item.type == 8 && e.LoginType == 'linkedIn') item.url = e.LoginUrl
          })
        })
        console.log('this.icon: ', this.icon)

        this.$forceUpdate() // 强制渲染
      }
      // else if (this.switchState == 2) {
      //   this.icon[0].url = result[0].LoginUrl
      //   this.icon[1].url = result[1].LoginUrl
      //   this.icon2[0].url = result[0].LoginUrl
      //   this.icon2[1].url = result[1].LoginUrl
      // }
      if (this.$store.state.myCountry != 'cn') {
        // 谷歌
        const googleSignInAPI = document.createElement('script')
        googleSignInAPI.setAttribute('src', 'https://accounts.google.com/gsi/client')
        document.head.appendChild(googleSignInAPI)
        const _that = this
        googleSignInAPI.onload = function () {
          // InitGoogleButton 初始化登录按钮
          // eslint-disable-next-line no-undef
          google.accounts.id.initialize({
            client_id: _that.clientId,
            callback: _that.OnSuccess
          })

          // eslint-disable-next-line no-undef
          google.accounts.id.renderButton(document.getElementById('google-login-btn'), _that.googleBtnConfigs)
        }
      }

      // applyid
      const applyidSignInAPI = document.createElement('script')
      applyidSignInAPI.setAttribute('src', 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js')
      document.head.appendChild(applyidSignInAPI)
      const _that = this
      applyidSignInAPI.onload = function () {
        // eslint-disable-next-line no-undef
        AppleID.auth.init({
          clientId: 'com.wikifx.web',
          scope: 'name email',
          redirectURI: `https://www${_that.$store.state.cookieHost}`,
          state: 'xcoiv98y2kd22vusuye3kch',
          // nonce : '[NONCE]',
          usePopup: true
        })
      }
      const buttonElement = document.querySelector('.appleid-signin')
      const that = this
      buttonElement &&
        buttonElement.addEventListener(
          'click',
          () => {
            // eslint-disable-next-line no-undef
            AppleID.auth
              .signIn()
              .then(function (data) {
                console.log('1223', data)
                that.$api.usercenter
                  .getWaistcoat(
                    {
                      code: data.authorization.code
                    },
                    {
                      HttpMethod: 'get',
                      Route: 'usercenter$webapplecallback'
                    }
                  )
                  .then((res) => {
                    that.googleLogin(res)
                    console.log('appleid登录', res)
                  })
              })
              .catch(() => {
                console.log('apple')
              })
          },
          { passive: true }
        )
    },
    OnSuccess(resp) {
      this.onGoogleAuthSuccess(resp.credential)
    },
    onGoogleAuthSuccess(jwtCredentials) {
      console.log(jwtCredentials)
      this.$api.usercenter
        .getWaistcoat(
          {
            Token: jwtCredentials
          },
          {
            HttpMethod: 'post',
            Route: 'usercenter/web/googlecallback'
          }
        )
        .then((res) => {
          this.googleLogin(res)
        })
    },
    googleLogin(res) {
      if (res.isRegister) {
        this.$nextTick(() => {
          this.setCookie(res.cookieValue)
          if (res?.LoginToken?.expires_in) {
            const ntoken = `${res?.LoginToken?.token_type} ${res?.LoginToken?.access_token}`
            this.$cookies.set('logintoken', ntoken, {
              domain: this.$store.state.cookieHost,
              maxAge: res?.LoginToken?.expires_in,
              path: '/'
            }) // 存储token
            this.$cookies.set('quitetoken', `${res?.LoginToken?.access_token},${res?.LoginToken?.refresh_token}`, {
              // 获取退出时所需要的access_token-refresh_token
              domain: this.$store.state.cookieHost,
              maxAge: res?.LoginToken?.expires_in,
              path: '/'
            }) // 存储token
            this.$cookies.set('refreshtime', String(new Date().getTime()), {
              // 刷新时间
              domain: this.$store.state.cookieHost,
              maxAge: res?.LoginToken?.expires_in,
              path: '/'
            }) // 存储token
            this.$store.commit('loginverifyfn', false)
          }
        })
      } else {
        setTimeout(() => {
          if (process.client) {
            const href = window.location.href.substr(0, window.location.href.indexOf('?')) ? window.location.href.substr(0, window.location.href.indexOf('?')) : window.location.href
            const ulr = `?type=register&id=${res.id}&name=${res.nickName}&img=${res.img}&logintype=${res.loginType}&email=${res.email ? res.email : null}&returnurl=${href}`
            // console.log('`https:', `https://${this.$store.state.host}/${this.$store.state.LanguageCode}/login.html${ulr}`)
            window.location.href = `//${this.$store.state.host}/${this.$store.state.LanguageCode}/login.html${ulr}`
            // console.log('`//${thi', `//${this.$store.state.host}/${this.$store.state.LanguageCode}/login.html${ulr}`)
          }
        }, 500)
      }
    },
    setCookie(cookievalue) {
      if (!this.$store.state.userlogin2) this.$store.commit('loginClose', false)

      if (cookievalue) {
        this.$api.home.clientgetUsercookie({ contentcookie: cookievalue }).then((res) => {
          // 主账号信息
          this.$store.commit('setUser', {
            userId: res.result.userId,
            nick: res.result.nick,
            avatar: res.result.avatar,
            vest: false // 是否为马甲号
          })
        })
      }
      if (this.$store.state.host.includes('wikifx')) {
        this.CookieSet('DJkdikKMG', cookievalue, `.${this.$store.state.host.split('.')[1]}.${this.getSuffix(this.$store.state)}`)
      } else if (this.$store.state.host.includes('fxeye')) {
        this.CookieSet('ViLartidlakd', cookievalue, `.${this.$store.state.host.split('.')[1]}.${this.getSuffix(this.$store.state)}`)
      } else {
        this.$cookies.set('WsdsfgDGdagYms', cookievalue)
        // this.CookieSet(
        //   'WsdsfgDGdagYms',
        //   result.Value,
        //   `.${this.comurl}.${this.$store.state.my_domin}`
        // )
        const postdata = {
          op_type: 'setCookie',
          url: '',
          parm: cookievalue
        }
        window.parent.postMessage(postdata, '*')
      }
      const postdata = {
        op_type: 'reload',
        url: '',
        parm: cookievalue
      }
      window.parent && window.parent.postMessage(postdata, '*')
      this.$store.commit('setUsercookie', cookievalue)
    },
    CookieSet(key, val, dom) {
      // 存cookie
      const expiresTime = new Date(Date.now() + 8.64e7 * 999)
      this.$cookies.set(key, val, {
        expires: expiresTime,
        path: '/',
        domain: dom
      })
    }
  }
}
